module.exports = __webpack_public_path__ + "img/balloon-blue.5a85c5e3.svg";